import { UpdateIncidentPayload } from '../types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateIncident, updateIncidentReset } from '../services/actions/update';
import { selectUpdateIncidentApi } from '../services/selectors';

export const useUpdateIncident = (caseNumber?: string) => {
    const dispatch = useDispatch();

    return {
        api: useSelector(state =>
            selectUpdateIncidentApi(state, {
                caseNumber,
            }),
        ),
        updateIncident: useCallback(
            ({ payload }: { payload: UpdateIncidentPayload }) => {
                dispatch(
                    updateIncident({
                        payload,
                        caseNumber
                    }),
                );
            },
            [dispatch, caseNumber],
        ),
        resetUpload: useCallback(() => {
            dispatch(updateIncidentReset(caseNumber));
        }, [dispatch, caseNumber]),
    };
};
